import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';

const CtaSection = () => {
    const { t } = useLanguage();

    return (
        <section className="py-20 bg-gradient-to-br from-[#0A5F7F] to-[#0D7FA3] text-white">
            <div className="container mx-auto px-4 text-center">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                >
                    <h2 className="text-3xl md:text-4xl font-bold mb-6">
                        {t('home.ctaTitle')}
                    </h2>
                    <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
                        {t('home.ctaSubtitle')}
                    </p>
                    <Link to="/contacto">
                        <Button size="lg" className="bg-white text-[#0A5F7F] hover:bg-white/90">
                            {t('home.scheduleBtn')}
                            <ArrowRight className="ml-2 h-5 w-5" />
                        </Button>
                    </Link>
                </motion.div>
            </div>
        </section>
    );
};

export default CtaSection;
